export default {
    methods: {
        // zwraca długość trwania programu na podstawie daty rozpoczęcia i zakończenia
        getProgramProgress(start, end) {
            if (start) {
                const duration = this.getProgramDuration(start, end);
                const currentTime = new Date().getTime();
                const startD = new Date(start);
                const progress = Math.abs(
                    Math.round((currentTime - startD) / 1000 / 60)
                );
                const progressPercent =
                    progress / duration === 0 ? 1 : (progress / duration) * 100;

                return `${progressPercent}`;
            }
            return '';
        }
    }
};
